import { render, staticRenderFns } from "./AcctNoSfxHelpList.vue?vue&type=template&id=499b9991&"
import script from "./AcctNoSfxHelpList.vue?vue&type=script&lang=js&"
export * from "./AcctNoSfxHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports